const Footer = () => {
  return (
    // <footer className="sticky-footer bg-white">
    //   <div className="container my-auto">
    //     <div className="copyright text-center my-auto">
    //       <span>Copyright &copy; Offingus Software 2023-24</span>
    //     </div>
    //   </div>
    // </footer>
    <footer className="footer">
      <div className="d-sm-flex justify-content-center justify-content-sm-between text-center">
        {/* <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Premium <a
            href="https://www.bootstrapdash.com/" target="_blank">Bootstrap admin template</a> from BootstrapDash.</span> */}
        <span className="float-none float-sm-end d-block mt-1 mt-sm-0 text-center">
          Copyright &copy; Offingus Software 2023-24
        </span>
      </div>
    </footer>
  );
};

export default Footer;
